interface Props {
  type: string;
  className?: string;
}
export default function Icon({ type, className }: Props) {
  if (type === 'person') {
    return (
      <svg
        width="17"
        height="20"
        className={className}
        viewBox="0 0 17 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.49997 9.99999C7.53931 9.99999 6.60024 9.71513 5.80148 9.18142C5.00273 8.64771 4.38018 7.88913 4.01255 7.0016C3.64493 6.11407 3.54874 5.13746 3.73615 4.19527C3.92357 3.25308 4.38617 2.38762 5.06545 1.70833C5.74473 1.02905 6.61019 0.56645 7.55239 0.379036C8.49458 0.191622 9.47119 0.28781 10.3587 0.655436C11.2462 1.02306 12.0048 1.64561 12.5385 2.44437C13.0722 3.24312 13.3571 4.1822 13.3571 5.14285C13.3571 6.43104 12.8454 7.66648 11.9345 8.57737C11.0236 9.48826 9.78816 9.99999 8.49997 9.99999ZM8.49997 1.49999C7.77948 1.49999 7.07517 1.71364 6.4761 2.11393C5.87704 2.51421 5.41013 3.08314 5.13441 3.74879C4.85869 4.41443 4.78654 5.14689 4.9271 5.85354C5.06766 6.56018 5.41461 7.20928 5.92407 7.71874C6.43354 8.2282 7.08264 8.57515 7.78928 8.71571C8.49593 8.85627 9.22838 8.78413 9.89403 8.50841C10.5597 8.23269 11.1286 7.76578 11.5289 7.16671C11.9292 6.56765 12.1428 5.86334 12.1428 5.14285C12.145 4.66272 12.0524 4.18688 11.8703 3.74259C11.6883 3.29829 11.4205 2.89426 11.0821 2.55363C10.7437 2.213 10.3415 1.94245 9.89839 1.75749C9.45531 1.57252 8.9801 1.47677 8.49997 1.47571V1.49999Z"
          fill="currentColor"
        />
        <path
          d="M16.3929 19.7143C16.2325 19.7122 16.0793 19.6475 15.9659 19.5341C15.8525 19.4207 15.7878 19.2675 15.7857 19.1071C15.7857 17.1748 15.0181 15.3217 13.6518 13.9553C12.2854 12.589 10.4323 11.8214 8.5 11.8214C6.56771 11.8214 4.71456 12.589 3.34822 13.9553C1.98189 15.3217 1.21429 17.1748 1.21429 19.1071C1.21429 19.2681 1.15032 19.4226 1.03646 19.5364C0.922594 19.6503 0.768167 19.7143 0.607143 19.7143C0.446119 19.7143 0.291692 19.6503 0.177831 19.5364C0.0639693 19.4226 0 19.2681 0 19.1071C0 16.8528 0.895533 14.6908 2.48959 13.0967C4.08365 11.5027 6.24566 10.6071 8.5 10.6071C10.7543 10.6071 12.9163 11.5027 14.5104 13.0967C16.1045 14.6908 17 16.8528 17 19.1071C17 19.2681 16.936 19.4226 16.8222 19.5364C16.7083 19.6503 16.5539 19.7143 16.3929 19.7143Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'calendarBlank') {
    return (
      <svg
        width="19"
        height="20"
        className={className}
        viewBox="0 0 17 20"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          d="M14.9876 3.46875H3.84334C3.5356 3.46875 3.28613 3.73458 3.28613 4.0625V15.9375C3.28613 16.2654 3.5356 16.5312 3.84334 16.5312H14.9876C15.2953 16.5312 15.5448 16.2654 15.5448 15.9375V4.0625C15.5448 3.73458 15.2953 3.46875 14.9876 3.46875Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7585 2.28125V4.65625"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.07202 2.28125V4.65625"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.28613 7.03125H15.5448"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === 'share') {
    return (
      <svg
        className={className}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.55469 5.25781L11 1.8125L14.4453 5.25781"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 11V1.8125"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9375 8.375H16.9062C17.0803 8.375 17.2472 8.44414 17.3703 8.56721C17.4934 8.69028 17.5625 8.8572 17.5625 9.03125V17.5625C17.5625 17.7365 17.4934 17.9035 17.3703 18.0265C17.2472 18.1496 17.0803 18.2188 16.9062 18.2188H5.09375C4.9197 18.2188 4.75278 18.1496 4.62971 18.0265C4.50664 17.9035 4.4375 17.7365 4.4375 17.5625V9.03125C4.4375 8.8572 4.50664 8.69028 4.62971 8.56721C4.75278 8.44414 4.9197 8.375 5.09375 8.375H7.0625"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === 'emailBlank') {
    return (
      <svg
        width="16"
        height="13"
        className={className}
        viewBox="0 0 16 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7 0.5H1.69995C0.874951 0.5 0.207451 1.175 0.207451 2L0.199951 11C0.199951 11.825 0.874951 12.5 1.69995 12.5H13.7C14.525 12.5 15.2 11.825 15.2 11V2C15.2 1.175 14.525 0.5 13.7 0.5ZM13.7 11H1.69995V3.5L7.69995 7.25L13.7 3.5V11ZM7.69995 5.75L1.69995 2H13.7L7.69995 5.75Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'diamond') {
    return (
      <svg
        className={className}
        width="11"
        height="14"
        viewBox="0 0 11 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 13.9961C5.69141 13.9961 5.85091 13.9323 5.97852 13.8047C6.10612 13.6771 6.26335 13.488 6.4502 13.2373L10.2988 8.10352C10.39 7.97591 10.4606 7.85059 10.5107 7.72754C10.5609 7.59993 10.5859 7.46777 10.5859 7.33105C10.5859 7.19434 10.5609 7.06445 10.5107 6.94141C10.4606 6.8138 10.39 6.6862 10.2988 6.55859L6.4502 1.4248C6.26335 1.17415 6.10612 0.985026 5.97852 0.857422C5.85091 0.72526 5.69141 0.65918 5.5 0.65918C5.30859 0.65918 5.14909 0.72526 5.02148 0.857422C4.89388 0.985026 4.73665 1.17415 4.5498 1.4248L0.708008 6.55859C0.607747 6.6862 0.532552 6.8138 0.482422 6.94141C0.436849 7.06445 0.414062 7.19434 0.414062 7.33105C0.414062 7.46777 0.436849 7.59993 0.482422 7.72754C0.532552 7.85059 0.607747 7.97591 0.708008 8.10352L4.5498 13.2373C4.73665 13.488 4.89388 13.6771 5.02148 13.8047C5.14909 13.9323 5.30859 13.9961 5.5 13.9961Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'map') {
    return (
      <svg
        className={className}
        width="11"
        height="14"
        viewBox="0 0 11 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 1C2.74 1 0.5 3.24 0.5 6C0.5 7.79 1.5 9.58 2.5 11.17C3.5 12.76 4.5 13.5 5.5 13.5C6.5 13.5 7.5 12.76 8.5 11.17C9.5 9.58 10.5 7.79 10.5 6C10.5 3.24 8.26 1 5.5 1ZM5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5C7 6.33 6.33 7 5.5 7Z"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
        />
      </svg>
    );
  }

  // Filled map pin
  // if (type === 'map') {
  //   return (
  //     <svg
  //       className={className}
  //       width="11"
  //       height="14"
  //       viewBox="0 0 11 14"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M5.5 0C2.73858 0 0.5 2.23858 0.5 5C0.5 8.25 5.5 14 5.5 14C5.5 14 10.5 8.25 10.5 5C10.5 2.23858 8.26142 0 5.5 0ZM5.5 7C4.11929 7 3 5.88071 3 4.5C3 3.11929 4.11929 2 5.5 2C6.88071 2 8 3.11929 8 4.5C8 5.88071 6.88071 7 5.5 7Z"
  //         fill="currentColor"
  //       />
  //     </svg>

  //   );
  // }

  if (type === 'arrowNext') {
    return (
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.16667 0L0.521667 1.645L5.865 7L0.521667 12.355L2.16667 14L9.16667 7L2.16667 0Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'chevronDown') {
    return (
      <svg
        width="10"
        height="14"
        viewBox="0 0 10 14"
        className={`${className} rotate-90`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.16667 0L0.521667 1.645L5.865 7L0.521667 12.355L2.16667 14L9.16667 7L2.16667 0Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'arrowPrevious') {
    return (
      <svg
        width="9"
        height="14"
        viewBox="0 0 9 14"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.02169 14L8.66669 12.355L3.32335 7L8.66669 1.645L7.02169 1.4381e-07L0.0216859 7L7.02169 14Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'checkmark') {
    return (
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8125 1.37488L4.39219 7.49984L1.1875 4.43736"
          stroke="#C9964D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (type === 'clock') {
    return (
      <svg
        data-testid="time-quick-action"
        width="22"
        height="22"
        viewBox="0 0 17 17"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4.58069 9.20312C4.42444 9.20312 4.29423 9.15104 4.19006 9.04688C4.0859 8.94271 4.03381 8.8125 4.03381 8.65625C4.03381 8.50521 4.0859 8.3776 4.19006 8.27344C4.29423 8.16927 4.42444 8.11719 4.58069 8.11719H8.11975V3.39062C8.11975 3.23958 8.17183 3.11198 8.276 3.00781C8.38017 2.90365 8.50777 2.85156 8.65881 2.85156C8.81506 2.85156 8.94527 2.90365 9.04944 3.00781C9.15361 3.11198 9.20569 3.23958 9.20569 3.39062V8.65625C9.20569 8.8125 9.15361 8.94271 9.04944 9.04688C8.94527 9.15104 8.81506 9.20312 8.65881 9.20312H4.58069ZM8.66663 16.3281C9.75517 16.3281 10.7786 16.1198 11.7369 15.7031C12.7005 15.2865 13.5494 14.7109 14.2838 13.9766C15.0182 13.2422 15.5937 12.3958 16.0104 11.4375C16.427 10.474 16.6354 9.44792 16.6354 8.35938C16.6354 7.27083 16.427 6.2474 16.0104 5.28906C15.5937 4.32552 15.0182 3.47656 14.2838 2.74219C13.5494 2.00781 12.7005 1.43229 11.7369 1.01562C10.7734 0.598958 9.74736 0.390625 8.65881 0.390625C7.57027 0.390625 6.54423 0.598958 5.58069 1.01562C4.62236 1.43229 3.776 2.00781 3.04163 2.74219C2.31246 3.47656 1.73954 4.32552 1.32288 5.28906C0.906209 6.2474 0.697876 7.27083 0.697876 8.35938C0.697876 9.44792 0.906209 10.474 1.32288 11.4375C1.73954 12.3958 2.31506 13.2422 3.04944 13.9766C3.78381 14.7109 4.63017 15.2865 5.5885 15.7031C6.55204 16.1198 7.57808 16.3281 8.66663 16.3281Z"
          fill="currentColor"
          fillOpacity="0.75"
        />
      </svg>
    );
  }

  if (type === 'comment') {
    return (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1505_9552)" filter="url(#filter0_d_1505_9552)">
          <path
            d="M8.15616 18.9763C8.06238 18.9797 7.9694 18.9578 7.88699 18.9129C7.78734 18.8654 7.70362 18.79 7.646 18.6959C7.58838 18.6017 7.55934 18.4929 7.56241 18.3825V15.4375H5.78116C5.30875 15.4375 4.85568 15.2498 4.52163 14.9158C4.18758 14.5817 3.99991 14.1287 3.99991 13.6563V1.78126C3.99677 1.54535 4.04052 1.31117 4.12863 1.09231C4.21673 0.873447 4.34744 0.67427 4.51316 0.506342C4.67888 0.338414 4.8763 0.20508 5.09398 0.114082C5.31165 0.0230848 5.54524 -0.0237636 5.78116 -0.0237427H21.2187C21.6911 -0.0237427 22.1441 0.163924 22.4782 0.497973C22.8122 0.832022 22.9999 1.28509 22.9999 1.75751V13.6325C22.9999 14.1049 22.8122 14.558 22.4782 14.892C22.1441 15.2261 21.6911 15.4138 21.2187 15.4138H13.0962L8.50449 18.8575C8.40415 18.9335 8.28202 18.9751 8.15616 18.9763ZM5.78116 1.16376C5.62369 1.16376 5.47267 1.22631 5.36132 1.33766C5.24997 1.44901 5.18741 1.60003 5.18741 1.75751V13.6325C5.18635 13.7108 5.20098 13.7885 5.23044 13.861C5.2599 13.9335 5.30359 13.9994 5.35894 14.0547C5.41429 14.1101 5.48017 14.1538 5.55269 14.1832C5.62521 14.2127 5.7029 14.2273 5.78116 14.2263H8.15616C8.313 14.2283 8.46283 14.2915 8.57374 14.4024C8.68465 14.5133 8.74786 14.6632 8.74991 14.82V17.195L12.5499 14.345C12.653 14.2684 12.7778 14.2268 12.9062 14.2263H21.2187C21.3761 14.2263 21.5272 14.1637 21.6385 14.0524C21.7499 13.941 21.8124 13.79 21.8124 13.6325V1.75751C21.8104 1.60067 21.7472 1.45084 21.6362 1.33993C21.5253 1.22902 21.3755 1.16581 21.2187 1.16376H5.78116Z"
            fill="currentColor"
          />
          <path
            d="M8.15625 6.53125C7.99878 6.53125 7.84775 6.46869 7.7364 6.35734C7.62505 6.246 7.5625 6.09497 7.5625 5.9375C7.5625 5.78003 7.62505 5.62901 7.7364 5.51766C7.84775 5.40631 7.99878 5.34375 8.15625 5.34375H18.8438C19.0012 5.34375 19.1522 5.40631 19.2636 5.51766C19.3749 5.62901 19.4375 5.78003 19.4375 5.9375C19.4375 6.09497 19.3749 6.246 19.2636 6.35734C19.1522 6.46869 19.0012 6.53125 18.8438 6.53125H8.15625Z"
            fill="currentColor"
          />
          <path
            d="M8.15625 10.0938C7.99878 10.0938 7.84775 10.0312 7.7364 9.91985C7.62505 9.8085 7.5625 9.65747 7.5625 9.5C7.5625 9.34253 7.62505 9.19151 7.7364 9.08016C7.84775 8.96881 7.99878 8.90625 8.15625 8.90625H16.4688C16.6262 8.90625 16.7772 8.96881 16.8886 9.08016C16.9999 9.19151 17.0625 9.34253 17.0625 9.5C17.0625 9.65747 16.9999 9.8085 16.8886 9.91985C16.7772 10.0312 16.6262 10.0938 16.4688 10.0938H8.15625Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1505_9552"
            x="0"
            y="0"
            width="27"
            height="27"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1505_9552" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1505_9552"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_1505_9552">
            <rect width="19" height="19" fill="white" transform="translate(4)" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (type === 'date') {
    return (
      <svg
        data-testid="calendar-quick-action"
        width="22"
        height="22"
        viewBox="0 0 16 15"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M2.66406 14.5625H13.3359C14.1536 14.5625 14.7656 14.3594 15.1719 13.9531C15.5781 13.5521 15.7812 12.9479 15.7812 12.1406V2.60156C15.7812 1.79427 15.5781 1.1901 15.1719 0.789062C14.7656 0.382812 14.1536 0.179688 13.3359 0.179688H2.66406C1.84635 0.179688 1.23177 0.382812 0.820312 0.789062C0.414062 1.1901 0.210938 1.79427 0.210938 2.60156V12.1406C0.210938 12.9479 0.414062 13.5521 0.820312 13.9531C1.23177 14.3594 1.84635 14.5625 2.66406 14.5625ZM2.54688 13.3047C2.20312 13.3047 1.9375 13.2109 1.75 13.0234C1.5625 12.8411 1.46875 12.5703 1.46875 12.2109V4.84375C1.46875 4.48438 1.5625 4.21354 1.75 4.03125C1.9375 3.84375 2.20312 3.75 2.54688 3.75H13.4375C13.7865 3.75 14.0547 3.84375 14.2422 4.03125C14.4297 4.21354 14.5234 4.48438 14.5234 4.84375V12.2109C14.5234 12.5703 14.4297 12.8411 14.2422 13.0234C14.0547 13.2109 13.7865 13.3047 13.4375 13.3047H2.54688ZM6.47656 6.5625H6.9375C7.07292 6.5625 7.16667 6.53646 7.21875 6.48438C7.27604 6.43229 7.30469 6.33854 7.30469 6.20312V5.74219C7.30469 5.60677 7.27604 5.51562 7.21875 5.46875C7.16667 5.41667 7.07292 5.39062 6.9375 5.39062H6.47656C6.34115 5.39062 6.24479 5.41667 6.1875 5.46875C6.13542 5.51562 6.10938 5.60677 6.10938 5.74219V6.20312C6.10938 6.33854 6.13542 6.43229 6.1875 6.48438C6.24479 6.53646 6.34115 6.5625 6.47656 6.5625ZM9.07031 6.5625H9.53125C9.67188 6.5625 9.76823 6.53646 9.82031 6.48438C9.8724 6.43229 9.89844 6.33854 9.89844 6.20312V5.74219C9.89844 5.60677 9.8724 5.51562 9.82031 5.46875C9.76823 5.41667 9.67188 5.39062 9.53125 5.39062H9.07031C8.9349 5.39062 8.84115 5.41667 8.78906 5.46875C8.73698 5.51562 8.71094 5.60677 8.71094 5.74219V6.20312C8.71094 6.33854 8.73698 6.43229 8.78906 6.48438C8.84115 6.53646 8.9349 6.5625 9.07031 6.5625ZM11.6719 6.5625H12.125C12.2656 6.5625 12.362 6.53646 12.4141 6.48438C12.4661 6.43229 12.4922 6.33854 12.4922 6.20312V5.74219C12.4922 5.60677 12.4661 5.51562 12.4141 5.46875C12.362 5.41667 12.2656 5.39062 12.125 5.39062H11.6719C11.5312 5.39062 11.4349 5.41667 11.3828 5.46875C11.3307 5.51562 11.3047 5.60677 11.3047 5.74219V6.20312C11.3047 6.33854 11.3307 6.43229 11.3828 6.48438C11.4349 6.53646 11.5312 6.5625 11.6719 6.5625ZM3.88281 9.11719H4.34375C4.47917 9.11719 4.57292 9.09115 4.625 9.03906C4.67708 8.98698 4.70312 8.89323 4.70312 8.75781V8.30469C4.70312 8.16406 4.67708 8.07031 4.625 8.02344C4.57292 7.97135 4.47917 7.94531 4.34375 7.94531H3.88281C3.74219 7.94531 3.64583 7.97135 3.59375 8.02344C3.54167 8.07031 3.51562 8.16406 3.51562 8.30469V8.75781C3.51562 8.89323 3.54167 8.98698 3.59375 9.03906C3.64583 9.09115 3.74219 9.11719 3.88281 9.11719ZM6.47656 9.11719H6.9375C7.07292 9.11719 7.16667 9.09115 7.21875 9.03906C7.27604 8.98698 7.30469 8.89323 7.30469 8.75781V8.30469C7.30469 8.16406 7.27604 8.07031 7.21875 8.02344C7.16667 7.97135 7.07292 7.94531 6.9375 7.94531H6.47656C6.34115 7.94531 6.24479 7.97135 6.1875 8.02344C6.13542 8.07031 6.10938 8.16406 6.10938 8.30469V8.75781C6.10938 8.89323 6.13542 8.98698 6.1875 9.03906C6.24479 9.09115 6.34115 9.11719 6.47656 9.11719ZM9.07031 9.11719H9.53125C9.67188 9.11719 9.76823 9.09115 9.82031 9.03906C9.8724 8.98698 9.89844 8.89323 9.89844 8.75781V8.30469C9.89844 8.16406 9.8724 8.07031 9.82031 8.02344C9.76823 7.97135 9.67188 7.94531 9.53125 7.94531H9.07031C8.9349 7.94531 8.84115 7.97135 8.78906 8.02344C8.73698 8.07031 8.71094 8.16406 8.71094 8.30469V8.75781C8.71094 8.89323 8.73698 8.98698 8.78906 9.03906C8.84115 9.09115 8.9349 9.11719 9.07031 9.11719ZM11.6719 9.11719H12.125C12.2656 9.11719 12.362 9.09115 12.4141 9.03906C12.4661 8.98698 12.4922 8.89323 12.4922 8.75781V8.30469C12.4922 8.16406 12.4661 8.07031 12.4141 8.02344C12.362 7.97135 12.2656 7.94531 12.125 7.94531H11.6719C11.5312 7.94531 11.4349 7.97135 11.3828 8.02344C11.3307 8.07031 11.3047 8.16406 11.3047 8.30469V8.75781C11.3047 8.89323 11.3307 8.98698 11.3828 9.03906C11.4349 9.09115 11.5312 9.11719 11.6719 9.11719ZM3.88281 11.6719H4.34375C4.47917 11.6719 4.57292 11.6484 4.625 11.6016C4.67708 11.5495 4.70312 11.4531 4.70312 11.3125V10.8594C4.70312 10.7188 4.67708 10.625 4.625 10.5781C4.57292 10.526 4.47917 10.5 4.34375 10.5H3.88281C3.74219 10.5 3.64583 10.526 3.59375 10.5781C3.54167 10.625 3.51562 10.7188 3.51562 10.8594V11.3125C3.51562 11.4531 3.54167 11.5495 3.59375 11.6016C3.64583 11.6484 3.74219 11.6719 3.88281 11.6719ZM6.47656 11.6719H6.9375C7.07292 11.6719 7.16667 11.6484 7.21875 11.6016C7.27604 11.5495 7.30469 11.4531 7.30469 11.3125V10.8594C7.30469 10.7188 7.27604 10.625 7.21875 10.5781C7.16667 10.526 7.07292 10.5 6.9375 10.5H6.47656C6.34115 10.5 6.24479 10.526 6.1875 10.5781C6.13542 10.625 6.10938 10.7188 6.10938 10.8594V11.3125C6.10938 11.4531 6.13542 11.5495 6.1875 11.6016C6.24479 11.6484 6.34115 11.6719 6.47656 11.6719ZM9.07031 11.6719H9.53125C9.67188 11.6719 9.76823 11.6484 9.82031 11.6016C9.8724 11.5495 9.89844 11.4531 9.89844 11.3125V10.8594C9.89844 10.7188 9.8724 10.625 9.82031 10.5781C9.76823 10.526 9.67188 10.5 9.53125 10.5H9.07031C8.9349 10.5 8.84115 10.526 8.78906 10.5781C8.73698 10.625 8.71094 10.7188 8.71094 10.8594V11.3125C8.71094 11.4531 8.73698 11.5495 8.78906 11.6016C8.84115 11.6484 8.9349 11.6719 9.07031 11.6719Z"
          fill="currentColor"
          fillOpacity="0.75"
        />
      </svg>
    );
  }

  if (type === 'decorativeSquare') {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 19 18"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="1" y="0.5" width="17.3077" height="16.4026" stroke="currentColor" />
        <rect x="5.88477" y="5.11792" width="7.53846" height="7.16578" fill="currentColor" />
      </svg>
    );
  }

  if (type === 'email') {
    return (
      <svg
        width="19"
        height="14"
        viewBox="0 0 19 14"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.90001 14C1.3961 14 0.912827 13.7981 0.556508 13.4388C0.200189 13.0795 9.62032e-06 12.5921 9.62032e-06 12.0839V1.86498C-0.00133527 1.43958 0.138364 1.02594 0.396899 0.689801C0.574537 0.47288 0.797749 0.29847 1.0504 0.179178C1.30305 0.059886 1.57882 -0.00130748 1.85779 2.11818e-05H17.0578C17.3365 0.000459485 17.6117 0.06244 17.864 0.181607C18.1164 0.300774 18.3399 0.474236 18.5187 0.689801C18.8071 1.01486 18.9769 1.42942 19 1.86498V12.0839C19 12.5921 18.7998 13.0795 18.4435 13.4388C18.0872 13.7981 17.6039 14 17.1 14H1.90001ZM1.26668 12.0839C1.26668 12.2533 1.3334 12.4158 1.45218 12.5356C1.57095 12.6553 1.73204 12.7226 1.90001 12.7226H17.1C17.2673 12.7204 17.4271 12.6524 17.5454 12.5331C17.6637 12.4138 17.7311 12.2526 17.7333 12.0839V2.12897L11.5858 6.89782C10.9872 7.36061 10.2543 7.61197 9.5 7.61315C8.74337 7.6107 8.00815 7.35957 7.40578 6.89782L1.26668 2.12897V12.0839ZM8.18267 5.88444C8.56047 6.17717 9.02357 6.33583 9.5 6.33578C9.98181 6.33704 10.4506 6.17844 10.8342 5.88444L16.8382 1.2263H2.17868L8.18267 5.88444Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'exclamationMark') {
    return (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18.6191C10.2246 18.6191 11.376 18.3848 12.4541 17.916C13.5381 17.4473 14.4932 16.7998 15.3193 15.9736C16.1455 15.1475 16.793 14.1953 17.2617 13.1172C17.7305 12.0332 17.9648 10.8789 17.9648 9.6543C17.9648 8.42969 17.7305 7.27832 17.2617 6.2002C16.793 5.11621 16.1455 4.16113 15.3193 3.33496C14.4932 2.50879 13.5381 1.86133 12.4541 1.39258C11.3701 0.923828 10.2158 0.689453 8.99121 0.689453C7.7666 0.689453 6.6123 0.923828 5.52832 1.39258C4.4502 1.86133 3.49805 2.50879 2.67188 3.33496C1.85156 4.16113 1.20703 5.11621 0.738281 6.2002C0.269531 7.27832 0.0351562 8.42969 0.0351562 9.6543C0.0351562 10.8789 0.269531 12.0332 0.738281 13.1172C1.20703 14.1953 1.85449 15.1475 2.68066 15.9736C3.50684 16.7998 4.45898 17.4473 5.53711 17.916C6.62109 18.3848 7.77539 18.6191 9 18.6191ZM9 11.2891C8.53125 11.2891 8.29102 11.0488 8.2793 10.5684L8.16504 5.77832C8.15918 5.5498 8.23242 5.35938 8.38477 5.20703C8.54297 5.05469 8.74512 4.97852 8.99121 4.97852C9.23145 4.97852 9.43066 5.05762 9.58887 5.21582C9.75293 5.36816 9.83203 5.55859 9.82617 5.78711L9.69434 10.5684C9.68848 11.0488 9.45703 11.2891 9 11.2891ZM9 14.2334C8.73633 14.2334 8.50488 14.1426 8.30566 13.9609C8.1123 13.7793 8.01562 13.5566 8.01562 13.293C8.01562 13.0352 8.1123 12.8125 8.30566 12.625C8.49902 12.4375 8.73047 12.3438 9 12.3438C9.26367 12.3438 9.49219 12.4375 9.68555 12.625C9.88477 12.8066 9.98438 13.0293 9.98438 13.293C9.98438 13.5566 9.88477 13.7793 9.68555 13.9609C9.49219 14.1426 9.26367 14.2334 9 14.2334Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'minus') {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM30 22H10V18H30V22Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'persons') {
    return (
      <svg
        data-testid="persons-quick-action"
        width="27"
        height="18"
        viewBox="0 0 27 18"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M12.2885 17.8945H24.5541C25.3223 17.8945 25.8627 17.7839 26.1752 17.5625C26.4877 17.3477 26.6439 17.0254 26.6439 16.5957C26.6439 15.9707 26.4519 15.3099 26.0677 14.6133C25.6901 13.9167 25.1433 13.2656 24.4271 12.6602C23.7175 12.0482 22.8549 11.5534 21.8392 11.1758C20.8301 10.7917 19.6908 10.5996 18.4213 10.5996C17.1582 10.5996 16.0189 10.7917 15.0033 11.1758C13.9942 11.5534 13.1316 12.0482 12.4154 12.6602C11.6993 13.2656 11.1524 13.9167 10.7748 14.6133C10.3972 15.3099 10.2084 15.9707 10.2084 16.5957C10.2084 17.0254 10.3614 17.3477 10.6674 17.5625C10.9799 17.7839 11.5202 17.8945 12.2885 17.8945ZM18.431 8.85156C19.1276 8.85156 19.7722 8.66276 20.3646 8.28516C20.9571 7.90104 21.4323 7.38346 21.7904 6.73242C22.1485 6.08138 22.3275 5.34896 22.3275 4.53516C22.3275 3.73438 22.1485 3.01823 21.7904 2.38672C21.4323 1.7487 20.9571 1.2474 20.3646 0.882812C19.7722 0.518229 19.1276 0.335938 18.431 0.335938C17.7344 0.335938 17.0899 0.521484 16.4974 0.892578C15.905 1.26367 15.4265 1.76823 15.0619 2.40625C14.7038 3.04427 14.5248 3.76042 14.5248 4.55469C14.5248 5.36198 14.7038 6.09115 15.0619 6.74219C15.42 7.38672 15.8952 7.90104 16.4877 8.28516C17.0801 8.66276 17.7279 8.85156 18.431 8.85156ZM1.74158 17.8945H9.15369C8.89978 17.5234 8.77934 17.0775 8.79236 16.5566C8.80538 16.0358 8.92582 15.4889 9.15369 14.916C9.38155 14.3431 9.69405 13.7897 10.0912 13.2559C10.4948 12.7155 10.9603 12.2402 11.4877 11.8301C10.9408 11.4655 10.3125 11.166 9.60291 10.9316C8.89978 10.6908 8.09249 10.5703 7.18103 10.5703C6.08077 10.5703 5.08793 10.7526 4.20251 11.1172C3.32361 11.4753 2.57166 11.9505 1.94666 12.543C1.32817 13.1289 0.852905 13.7702 0.520874 14.4668C0.188843 15.1634 0.0228271 15.8503 0.0228271 16.5273C0.0228271 16.9635 0.153035 17.2988 0.413452 17.5332C0.680379 17.7741 1.12309 17.8945 1.74158 17.8945ZM7.18103 9.07617C7.79301 9.07617 8.35616 8.91016 8.87048 8.57812C9.38481 8.24609 9.79822 7.79688 10.1107 7.23047C10.4232 6.65755 10.5795 6.01953 10.5795 5.31641C10.5795 4.61328 10.4232 3.98828 10.1107 3.44141C9.79822 2.88802 9.38155 2.45508 8.86072 2.14258C8.34639 1.82357 7.7865 1.66406 7.18103 1.66406C6.58207 1.66406 6.02218 1.82682 5.50134 2.15234C4.98702 2.47135 4.57035 2.90755 4.25134 3.46094C3.93233 4.01432 3.77608 4.63932 3.78259 5.33594C3.78259 6.03255 3.93884 6.66406 4.25134 7.23047C4.56384 7.79688 4.97725 8.24609 5.49158 8.57812C6.01241 8.91016 6.57556 9.07617 7.18103 9.07617Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'phone') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0082 19.9997C14.0086 19.9965 13.0309 19.7069 12.1905 19.1652C7.71768 16.145 3.86368 12.2958 0.836494 7.82533C0.18705 6.81804 -0.0977071 5.61831 0.0297257 4.42628C0.157159 3.23424 0.689076 2.12198 1.53674 1.27505L2.17864 0.632541C2.58487 0.227449 3.13493 0 3.70835 0C4.28177 0 4.83182 0.227449 5.23806 0.632541L7.95569 3.35278C8.36039 3.75941 8.58762 4.30999 8.58762 4.88396C8.58762 5.45793 8.36039 6.00852 7.95569 6.41514C7.87024 6.49973 7.80241 6.60044 7.75611 6.71144C7.70982 6.82244 7.68598 6.94154 7.68598 7.06182C7.68598 7.18211 7.70982 7.30121 7.75611 7.41221C7.80241 7.52321 7.87024 7.62392 7.95569 7.70851L12.3156 12.0726C12.4856 12.2402 12.7146 12.3342 12.9533 12.3342C13.1919 12.3342 13.421 12.2402 13.591 12.0726C13.9973 11.6675 14.5473 11.44 15.1207 11.44C15.6941 11.44 16.2442 11.6675 16.6504 12.0726L19.3681 14.7928C19.7728 15.1994 20 15.75 20 16.324C20 16.898 19.7728 17.4486 19.3681 17.8552L18.7262 18.4977C18.2362 18.9814 17.6554 19.3632 17.0173 19.621C16.3791 19.8788 15.6963 20.0075 15.0082 19.9997ZM12.8574 18.1139C13.5001 18.5244 14.2458 18.7443 15.0082 18.748C15.5323 18.7483 16.0512 18.6445 16.5349 18.4425C17.0185 18.2405 17.4573 17.9445 17.8259 17.5715L18.4677 16.9206C18.5532 16.836 18.621 16.7353 18.6673 16.6243C18.7136 16.5133 18.7375 16.3942 18.7375 16.2739C18.7375 16.1536 18.7136 16.0346 18.6673 15.9235C18.621 15.8125 18.5532 15.7118 18.4677 15.6273L15.7501 12.9154C15.5783 12.7447 15.3461 12.6489 15.1041 12.6489C14.862 12.6489 14.6298 12.7447 14.458 12.9154C14.2583 13.1168 14.0206 13.2767 13.7587 13.3855C13.4969 13.4944 13.216 13.5501 12.9325 13.5495C12.3614 13.5502 11.8132 13.3253 11.4069 12.9237L7.07204 8.593C6.66734 8.18638 6.44011 7.6358 6.44011 7.06182C6.44011 6.48785 6.66734 5.93727 7.07204 5.53065C7.24058 5.35766 7.33492 5.12559 7.33492 4.88396C7.33492 4.64233 7.24058 4.41026 7.07204 4.23728L4.35441 1.51704C4.26889 1.43192 4.16744 1.36452 4.05586 1.3187C3.94429 1.27288 3.82478 1.24954 3.70418 1.25002C3.58471 1.24878 3.46623 1.2718 3.3559 1.3177C3.24557 1.36359 3.14569 1.4314 3.06228 1.51704L2.41205 2.15955C1.75896 2.80362 1.34828 3.6538 1.24954 4.56616C1.1508 5.47852 1.37005 6.39701 1.87019 7.16613C4.79732 11.5133 8.53329 15.2557 12.8741 18.189L12.8574 18.1139Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'decorativeBorderTop') {
    return (
      <svg
        width="291"
        height="18"
        viewBox="0 0 291 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle
          cx="288.5"
          cy="15.5"
          r="2.5"
          transform="rotate(-180 288.5 15.5)"
          fill="currentColor"
        />
        <rect
          x="287"
          y="16"
          width="283"
          height="1"
          transform="rotate(-180 287 16)"
          fill="currentColor"
        />
        <path
          d="M0 15.5C0 14.1193 1.11929 13 2.5 13C3.88071 13 5 14.1193 5 15.5C5 16.8807 3.88071 18 2.5 18C1.11929 18 0 16.8807 0 15.5Z"
          fill="currentColor"
        />
        <rect
          x="146"
          y="16"
          width="1"
          height="11"
          transform="rotate(-180 146 16)"
          fill="currentColor"
        />
        <circle
          cx="145.5"
          cy="2.5"
          r="2.5"
          transform="rotate(-180 145.5 2.5)"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'decorativeBorderMiddle') {
    return (
      <svg
        width="343"
        height="18"
        viewBox="0 0 343 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <line y1="8.5" x2="152.5" y2="8.5" stroke="currentColor" />
        <g clipPath="url(#clip0_1238_7224)">
          <path
            d="M176.75 11.625V8.25L171.5 12L166.25 8.25V11.625L171.5 15.375L176.75 11.625Z"
            fill="currentColor"
          />
          <path
            d="M176.75 6.375V3L171.5 6.75L166.25 3V6.375L171.5 10.125L176.75 6.375Z"
            fill="currentColor"
          />
        </g>
        <line x1="190.5" y1="8.5" x2="343" y2="8.5" stroke="currentColor" />
        <defs>
          <clipPath id="clip0_1238_7224">
            <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 180.5 0)" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  if (type === 'decorativeBorderBottom') {
    return (
      <svg
        width="291"
        height="18"
        viewBox="0 0 291 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
        <rect x="4" y="2" width="283" height="1" fill="currentColor" />
        <path
          d="M291 2.5C291 3.88071 289.881 5 288.5 5C287.119 5 286 3.88071 286 2.5C286 1.11929 287.119 0 288.5 0C289.881 0 291 1.11929 291 2.5Z"
          fill="currentColor"
        />
        <rect x="145" y="2" width="1" height="11" fill="currentColor" />
        <circle cx="145.5" cy="15.5" r="2.5" fill="currentColor" />
      </svg>
    );
  }

  if (type === 'edit') {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 117.74 122.88"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M94.62,2c-1.46-1.36-3.14-2.09-5.02-1.99c-1.88,0-3.56,0.73-4.92,2.2L73.59,13.72l31.07,30.03l11.19-11.72 c1.36-1.36,1.88-3.14,1.88-5.02s-0.73-3.66-2.09-4.92L94.62,2L94.62,2L94.62,2z M41.44,109.58c-4.08,1.36-8.26,2.62-12.35,3.98 c-4.08,1.36-8.16,2.72-12.35,4.08c-9.73,3.14-15.07,4.92-16.22,5.23c-1.15,0.31-0.42-4.18,1.99-13.6l7.74-29.61l0.64-0.66 l30.56,30.56L41.44,109.58L41.44,109.58L41.44,109.58z M22.2,67.25l42.99-44.82l31.07,29.92L52.75,97.8L22.2,67.25L22.2,67.25z"
          fill="#9b720c"
        />
      </svg>
    );
  }

  if (type === 'plus') {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM30 22H22V30H18V22H10V18H18V10H22V18H30V22Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  if (type === 'star') {
    return (
      <svg
        width="13"
        height="12"
        viewBox="0 0 13 12"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 0L8.60133 3.64719L12.6819 4.54047L9.90003 7.68784L10.3206 11.8871L6.5 10.1851L2.6794 11.8871L3.09997 7.68784L0.318133 4.54047L4.39867 3.64719L6.5 0Z"
          fill="#C9964C"
        />
      </svg>
    );
  }

  if (type === 'starWithBorder') {
    return (
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 1.56724L8.1681 4.46247L8.27846 4.65402L8.49441 4.7013L11.7437 5.41261L9.52539 7.92239L9.38075 8.08603L9.40252 8.30334L9.73725 11.6455L6.70346 10.294L6.5 10.2034L6.29654 10.294L3.26275 11.6455L3.59748 8.30334L3.61925 8.08603L3.47461 7.92239L1.25631 5.41261L4.50559 4.7013L4.72154 4.65402L4.8319 4.46247L6.5 1.56724Z"
          fill="#C9964C"
          stroke="#e5e7eb"
        />
      </svg>
    );
  }

  if (type === 'starWithBorderInverted') {
    return (
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 1.57822L8.1681 4.47346L8.27846 4.66501L8.49441 4.71228L11.7437 5.42359L9.52539 7.93337L9.38075 8.09702L9.40252 8.31433L9.73725 11.6565L6.70346 10.305L6.5 10.2144L6.29654 10.305L3.26275 11.6565L3.59748 8.31433L3.61925 8.09702L3.47461 7.93337L1.25631 5.42359L4.50559 4.71228L4.72154 4.66501L4.8319 4.47346L6.5 1.57822Z"
          fill="white"
          stroke="#C9964C"
        />
      </svg>
    );
  } else return;
}
